import {createErrorHandlingThunk} from "../../../auth/redux/utils";
import {AdminService} from "./Admin.service";
import {CreateAdminData, FeAdmin, UpdateAdminInput, UpdateAdminResult, UpdateAdminStatusResult} from "./types";

const adminService = new AdminService();

export const createAdminThunk = createErrorHandlingThunk<FeAdmin, CreateAdminData>(
    'admins/create',
    (dto) => adminService.createAdmin(dto)
);

export const updateAdminThunk = createErrorHandlingThunk<UpdateAdminResult, { id: string, dto: UpdateAdminInput }>(
    'admins/update',
    (args) => adminService.updateAdmin(args.id, args.dto)
);

export const updateAdminStatusThunk = createErrorHandlingThunk<UpdateAdminStatusResult, { id: string, active: boolean }>(
    'admins/status/update',
    (args) => args.active ? adminService.activateAdmin(args.id) : adminService.deactivateAdmin(args.id)
);

export const listAdminsThunk = createErrorHandlingThunk(
    'admins/list',
    () => adminService.listAdmins()
);

export const getAdminThunk = createErrorHandlingThunk<FeAdmin, {id: string}>(
    'admins/get',
    (args) => adminService.getAdmin(args.id)
);